<template>
  <div class="testimonials">
    <h3 class="testimonials__header" v-bind:class="{ 'testimonials__header--small' : imageUrl }">{{formattedHeaderText}}</h3>
    <div v-if="imageUrl" class="testimonials__logo">
      <img :src="imageUrl" />
    </div>
    <div class="testimonials__avatars">
      <img
        class="testimonials__avatar"
        @click="setCurrentSelectedId(review.id)"
        v-for="review in testimonials"
        :src="review.image"
        :key="review.id"
        :class="getAvatarState(review.id)">
    </div>
    <ul class="testimonials__list">
      <li
      class="testimonials__testimonial"
      :class="getTestimonialState(review.id)"
      v-for="review in testimonials"
      :key="review.name">
        <div>
          <mark class="brand-primary"><strong>{{review.name}}</strong></mark>
        </div>
        <div class="testimonials__stars">
          <i
            class="testimonials__star"
            v-for="fullStar in review.rating"
            :key="fullStar">
          </i>
          <i
            class="testimonials__star testimonials__star--empty"
            v-for="emptyStar in remainderStars"
            :key="emptyStar.id">
          </i>
        </div>
        <span class="testimonials__review">
          {{review.review}}
        </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';
import Review from '../../models/Review';
import { tokenService } from '../../services/TokenService';

@Component
export default class TestimonialsComponent extends Vue {
  @Prop({ default: 'Don\'t just take our word for it...' })
  public headerText!: string;

  @Prop({
    default: () => [new Review(
      1,
      'Alan',
      'Askaprice did everything well, from their excellent staff to the service they provided.',
      5,
      '//styles.uk-tla.com/img/Alan.png'
    ),
    new Review(
      2,
      'Jo',
      'Askaprice are a great company and I’m very pleased with the service I received from them.',
      5,
      '//styles.uk-tla.com/img/Jo.png'
    ),
    new Review(
      3,
      'Mark',
      'Askaprice gave me exactly what I needed and they provided more options that I hadn’t considered before.',
      4,
      '//styles.uk-tla.com/img/Mark.png'
    )]
  })
  public testimonials!: Review[];

  @Prop({ default: '' })
  public imageUrl!: string;

  public get formattedHeaderText() {
    return tokenService.replaceToken(this.headerText);
  }

  private selectedTestimonalId: number = 1;

  get remainderStars(): number {
    return 5 - this.currentTestimonial.rating;
  }

  get currentTestimonial(): Review {
    return this.testimonials.filter((x) => x.id === this.selectedTestimonalId)[0];
  }

  public getTestimonialState(id: number): string {
    return this.currentTestimonial.id !== id
      ? 'testimonials__testimonial--hidden'
      : '';
  }

  public getAvatarState(id: number): string {
    return this.selectedTestimonalId !== id
      ? ''
      : 'testimonials__avatar--active';
  }

  public setCurrentSelectedId(id: number) {
    this.selectedTestimonalId = id;
  }
}
</script>
